import { NgClass } from '@angular/common';
import { Component, Input, input, output } from '@angular/core';
import { StatisticService } from '../statistic.service';


export type Month = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
export type MonthOfYear = {
  year: number;
  month: Month
};


@Component({
  selector: 'app-statistics-month-selector',
  imports: [NgClass],
  templateUrl: './statistics-month-selector.component.html',
  styleUrl: './statistics-month-selector.component.scss'
})
export class StatisticsMonthSelectorComponent {

  public readonly minMonth = input<MonthOfYear>();
  public readonly maxMonth = input<MonthOfYear>();
  @Input({ required: true }) public value!: MonthOfYear;
  public readonly valueChange = output<MonthOfYear>();


  constructor(private statService: StatisticService) { }

  public get isMinMonth(): boolean {
    const minMonth = this.minMonth();
    if (minMonth == undefined) return true;
    return this.value.year === minMonth.year && this.value.month === minMonth.month;
  }

  public get isMaxMonth(): boolean {
    const maxMonth = this.maxMonth();
    if (maxMonth == undefined) return true;
    return this.value.year === maxMonth.year && this.value.month === maxMonth.month;
  }

  public addMonth() {
    if (this.isMaxMonth) return;
    if (this.value.month === 12) {
      this.value = { year: this.value.year + 1, month: 1 };
    } else {
      this.value = { year: this.value.year, month: (this.value.month + 1) as Month };
    }
    this.valueChange.emit(this.value);
  }

  public substractMonth() {
    if (this.isMinMonth) return;
    if (this.value.month === 1) {
      this.value = { year: this.value.year - 1, month: 12 };
    } else {
      this.value = { year: this.value.year, month: (this.value.month - 1) as Month };
    }
    this.valueChange.emit(this.value);
  }

  public getSelectedMonthString(): string {
    return `${this.statService.getMonth(this.value.month)} ${this.value.year.toString()}`;
  }
}
